const delayType = [
  {
    value: 'days',
    label: '# of Days'
  }
];

export default delayType;
